import { render, staticRenderFns } from "./open_ai.vue?vue&type=template&id=4cb7422b&scoped=true&v-once=true"
import script from "./open_ai.vue?vue&type=script&lang=js"
export * from "./open_ai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb7422b",
  null
  
)

export default component.exports